var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevokedConsent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "",
    height: "",
    viewBox: "0 0 36 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3457 25.0787V5.09207C30.2997 3.91007 29.5352 1.57369 26.8457 1.68422C24.1563 1.68422 15.3174 1.56141 11.2341 1.5M11.2341 1.5L1.65527 10.8025M11.2341 1.5C11.2341 2.69736 11.2341 5.58943 11.2341 7.57887C11.2341 9.56831 9.29991 10.8025 7.91835 10.8025H1.65527M1.65527 10.8025V38.2035C1.77808 39.278 2.53026 41.0587 4.69471 41.4732C6.721 41.4732 11.8174 41.4885 14.0433 41.4732",
    stroke: "black",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.359 31.3877L22.4708 36.8219C21.7493 37.6662 19.7169 39.7416 17.359 42.21C15.9074 43.7297 18.5103 46.5849 20.3064 44.9731L25.8326 39.6771C26.462 40.2758 28.3747 42.1731 30.9904 44.9731C32.8325 46.677 35.1812 43.8218 33.8457 42.4402L28.5957 36.8219C29.1791 36.1157 31.0457 34.0403 33.8457 31.3877C35.5496 29.7735 32.4641 27.2891 30.9904 28.6707L25.5102 33.8745C24.6199 33.0456 22.3327 30.8443 20.3064 28.6707C18.675 26.9207 15.9775 29.7759 17.359 31.3877Z",
    stroke: "#009FDF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevokedConsent);
export default __webpack_public_path__ + "static/media/revokedConsent.957532564138fbe915834bd82ba85f65.svg";
export { ForwardRef as ReactComponent };